<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc" role="doc-toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="enc">
<div class="SOM_pre"><a href="#/pre2">List of Figures</a></div>
<div class="SOM_pre"><a href="#/pre3">Foreword by Jeremy Begbie</a></div>
<div class="SOM_pre"><a href="#/pre4">Acknowledgments</a></div>
<div class="SOM_pre"><a href="#/pre5">Introduction</a></div>
<div class="SOM_chap"><a href="#/chap1"><span class="mev1">1</span> <b>The Conversation Between Music and Preaching</b><br/><span class="mev2"><i>Four Models</i></span></a></div>
<div class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample"><span class="mev1">2</span> <b>Shaping Communal Time:</b><br/><span class="mev2"><i>Synchrony and Unity</i></span></span></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample"><span class="mev1">3</span> <b>Sanctification Through Hearing:</b><br/><span class="mev2"><i>Repetition and Patience</i></span></span></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample"><span class="mev1">4</span> <b>The End(s) of the Sermon:</b><br/><span class="mev2"><i>Teleology and Hope</i></span></span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample"><span class="mev1">5</span> <b>A Musical Homiletic in Practice</b></span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Bibliography</span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">General Index</span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">Scripture Index</span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample">Dynamics of Christian Worship</span></div>
<div class="SOM_appen"><span href="#/appen10" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen11" title="Link target outside of Sample">Praise For <i>Sermons That Sing</i></span></div>
<div class="SOM_appen"><span href="#/appen12" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?0d6f2048